<template>
    <div class="order-progress-wrap">
        <div class="breadBox">
            <el-button class="backBtn" @click="back"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>选择生产商</span></div>
        </div>
        <div class="producer-wrap">
            <div class="title">已接单生产商列表：</div>
            <el-card class="box-card" v-for="(item, index) in factoryList" :key="index">
                <div slot="header" class="clearfix">
                    <span>{{item.company_name}}</span>
                    <el-button style="float: right; padding: 3px 0; margin-left: 15px;" type="text" @click="toJiedanDetail(item)">查看</el-button>
                    <el-button style="float: right; padding: 3px 0; margin-left: 15px;" type="text" @click="confirmFactory(item)" v-if="fdInfo.order_status==10300 && item.cancelStatus == 'n'">选择此厂</el-button>
                    <span v-if="item.cancelStatus == 'y'" class="status">该生产商已取消接单</span>
                </div>
                <div style="margin-bottom: 10px;">
                    <el-rate
                        v-model="item.score"
                        disabled
                        show-score
                        text-color="#ff9900"
                    >
                    </el-rate>
                </div>
                <div class="text item">
                    地址：{{item.company_province+''+item.company_city+''+item.company_district }}   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 人数： {{item.staffNumber}} 人
                </div>
                <div class="text item">
                    擅长品类：{{item.category}}
                </div>
                <div class="text item">
                    擅长工艺：{{item.craft}}
                </div>
            </el-card>
          
        </div>
        
        
       
      

    </div>
</template>

<script>
    import { ajaxPost, api } from '@/common/request.js'
    import { ajaxApp, api_app } from '@/common/request_app.js'
    import axios from 'axios'
    export default {
        name: '',
        data() {
            return {
                orderNumber: '', // 订单号
                fdUserId: '', // 发单方 - userId
                fdInfo: {}, // 发单方 - 订单信息
                factoryList: [],

            }
        },
        computed: {
        	
        },
        created() {
            this.getParam()
            this.getFdOrderProgress()
        },
        methods: {
            // 页面返回
            back(){
            	this.$router.back()
            },
            // 获取url参数
            getParam(){
            	this.orderNumber=this.$route.params.orderNumber
                this.fdUserId = this.$route.query.id
            },
            // 获取订单动态数据 -- 发单方
            getFdOrderProgress() {
                let _this = this
                let arg = {
                    orderNumber: this.orderNumber,
                    userId: this.fdUserId
                }
                ajaxApp('/yijiajiaOrder/orderProgressPinpai',arg).then(res => {
                    console.log(res)
                    if(res.data.jiedanfang.length>0){
                        this.factoryList = res.data.jiedanfang.map((item, index) => {
                            // 品类
                            let categoryAll = item.regStr ? JSON.parse(item.regStr) : [];
                            let categoryShow = [];
                            let categoryStr = '';
                            if (categoryAll.product && categoryAll.product.length > 0) {
                                categoryAll.product.forEach(ele1 => {
                                    if (ele1.checked) {
                                        ele1.list.forEach(ele2 => {
                                            if (ele2.checked) {categoryShow.push(ele2.name)}
                                        })
                                    }
                                })
                            }
                            categoryStr = categoryShow.join('、');
                            
                            // 工艺
                            let staffDevice = item.staffDevice ? JSON.parse(item.staffDevice) : [];
                            let staffDeviceShow = [];
                            let staffDeviceStr = '';
                            console.log(staffDevice);
                            if (staffDevice.handleNeedProcessingLink && staffDevice.handleNeedProcessingLink.list.length > 0) {
                                staffDevice.handleNeedProcessingLink.list.forEach(ele => {
                                    if (ele.isSelect == '1') {
                                        staffDeviceShow.push(ele.dataName);
                                    }
                                })
                            }
                            if (staffDevice.handleSpecialProcess && staffDevice.handleSpecialProcess.list.length > 0) {
                                staffDevice.handleSpecialProcess.list.forEach(ele => {
                                    if (ele.isSelect == '1') {
                                        staffDeviceShow.push(ele.dataName);
                                    }
                                })
                            }
                            staffDeviceStr = staffDeviceShow.join('、');
                            console.log(staffDeviceStr);
                            
                            let stars = 0;
                            if (item.user_produce_order_score && item.user_produce_order_score > 0 ) {
                               stars = parseFloat(item.user_produce_order_score) 
                            }
                            
                            return {
                                ...item,
                                score: stars,
                                category: categoryStr,
                                craft: staffDeviceStr
                            }
                        });
                    }else{
                        this.factoryList =[]
                    }

                    _this.fdInfo = res.data.info;
                   
                },function(err){
                    console.log(err)
                })
            },
            confirmFactory (item) {
				this.$confirm('您确定选择此生产商吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ajaxApp('/yijiajiaOrder/confirmFactory', {
                        userId: this.fdUserId,
						orderNumber: this.orderNumber,
						shengchanUserId: item.user_id
                    }).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
							this.refund();
							this.$message({
                                message: '确认工厂成功！',
                                type: 'success'
                            })
							this.back();
						} else {
							this.$message({
                                message: res.errorMsg,
                                type: 'warning'
                            })
						}
                    }, err => {
                        console.log(err)
                    })
                })
            },
            // 发起退款
			refund() {
                axios({
                    url: api_app.onlinePayUrl + '/v1/api/pay/allRefundOrder',
                    method: 'post',
                    data: {
                        type: '1',
                        orderNumber: this.orderNumber
                    }
                }).then(res => {
                    console.log(res)
                }, err => {
                    console.log(err)
                })
            },
            toJiedanDetail(list) {
                this.$router.push({ name: 'customerDetail', params: { userId: list.user_id,href:'jiedanDetail' }})
                // this.$router.push({ name: 'factoryDetail', params: {  userId: list.user_id,orderNumber:this.orderNumber,orderType:this.orderType}})

            },
            
        }
    }
</script>

<style scoped lang="scss">
.producer-wrap {
    max-width: 800px;
    padding: 20px;
    .title {
        font-size: 18px;
    }
    .box-card {
        margin-top: 20px;
    }
    .status {
        float: right;
        background: #ccc;
        padding: 3px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/selectProducer.vue